export default function urlPrefixRelative(domain:string, url:string) {
    url = url.trim();
    
    if(url.indexOf('/') === 0) {
        domain = domain.trim().replace(/\/$/, '');
        return domain + url;
    }

    return url;
}